module.exports = __webpack_public_path__ + "static/media/lafc-latif-photos.9cc0b1bc.png";